<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-0"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center">
          <b-img
            v-if="mediaType==='IMAGE'"
            fluid
            :src="mediaUrl"
            alt="Login V2"
          />
          <video
            v-if="mediaType==='VIDEO'"
            autoplay
            loop
            muted
            style="height: 100vh;"
            :src="mediaUrl"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->

      <b-col
        lg="4"
        class=" auth-bg px-2 px-sm-5 relative"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="mx-auto"
        >
          <div
            class="mt-1 d-flex justify-content-between w-100"
          >
            <Locale />
            <dark-Toggler class=" d-block" />
          </div>
        </b-col>
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto mt-1"
        >
          <b-card-text
            v-if="!isSecondaryLoginPageDesignEnabled"
            class="text-center mb-2"
          >
            <span>{{ $t('New on our platform?') }}</span>
            <b-link :to="{ name: 'register' }">
              <b-button
                v-if="!pending"
                class="mt-1 "
                type="submit"
                variant="success"
                block
                style="height: 80px
                ;"
              >
                <p class="text-white h2">
                  {{ $t('create_account',{brand_name: getBrandName()}) }}
                </p>
              </b-button>
            </b-link>
          </b-card-text>
          <b-card-text
            v-if="isSecondaryLoginPageDesignEnabled"
            class="text-center mb-2"
          >
            <span>{{ $t('New on our platform?') }}</span>
            <b-link :to="{ name: 'register' }">
              <div
                v-if="!pending"
                class="mt-1 "
                block
                style="height: 80px;"
              >
                <p class="h3 text-success">
                  {{ $t('create_account',{brand_name: getBrandName()}) }}
                </p>
              </div>
            </b-link>
          </b-card-text>

          <b-card-title
            class="text-center mb-2 font-weight-bolder"
            style="margin-top:70px"
            title-tag="h2"
          >
            {{ $t('crypto_Cabin_Title', {brand_name: getBrandName()}) }}
          </b-card-title>
          <validation-observer
            ref="loginForm"
            #default="{ invalid }"
          >
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent="submit"
            >
              <!-- email -->
              <b-form-group
                :label="$t('email')"
                label-for="login-email"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('email')"
                  vid="email"
                  rules="required|email"
                >
                  <b-form-input
                    id="login-email"
                    v-model="form.email"
                    :state="errors.length > 0 ? false : null"
                    name="login-email"
                    placeholder="abc@example.com"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">{{ $t('password') }}</label>
                  <b-link :to="{ name: 'forgot-password' }">
                    <small>
                      {{ $t('forgot_password') }}
                    </small>
                  </b-link>
                </div>
                <validation-provider
                  #default="{ errors }"
                  :name="$t('password')"
                  vid="password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="form.password"
                      :state="errors.length > 0 ? false : null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      :placeholder="$t('password')"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-form-group>
                <div
                  dir="ltr"
                  class="google-captcha"
                >
                  <vue-recaptcha
                    ref="recaptcha"
                    :sitekey="sitekey"
                    :load-recaptcha-script="true"
                    :theme="$store.state.appConfig.layout.skin == 'dark' ? 'dark' : ''"
                    @expired="onCaptchaExpired"
                    @verify="onVerify"
                  />
                </div>
              </b-form-group>

              <!-- checkbox -->
              <b-form-group>
                <b-form-checkbox
                  id="remember-me"
                  v-model="rememberMe"
                  name="checkbox-1"
                >
                  {{ $t('Remember Me') }}
                </b-form-checkbox>
              </b-form-group>

              <!-- submit buttons -->
              <b-button
                v-if="!pending"
                type="submit"
                variant="primary"
                block
                :disabled="invalid || !form.recaptcha"
              >
                {{ $t('Sign in') }}
              </b-button>
              <b-button
                v-if="pending"
                variant="primary"
                block
                disabled
              >
                <b-spinner
                  small
                  type="grow"
                />
              </b-button>
            </b-form>
          </validation-observer>

        </b-col>
      </b-col>
      <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import Login from '@/views/logics/auth/Login'

export default {
  components: {
    DarkToggler,
    Locale: () => import(`@/layouts/${process.env.VUE_APP_THEME_NAME}/components/Locale.vue`),
  },
  mixins: [togglePasswordVisibility, Login],
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';

.language-image {
  width: 22px;
  aspect-ratio: auto 22 / 14;
  height: 14px;
}

.auth-wrapper #dropdown-grouped::marker {
  content: '';
}
</style>
